/**
 * Channels TanStack query key factory — keep in sync with channels.query-store usage.
 */
export const channelsQueryKeys = {
  /** Partial key: invalidates channel queries for all groups */
  root: () => ['channels'] as const,
  all: (gId?: string) => ['channels', gId] as const,
  list: (gId?: string) => ['channels', gId, 'list'] as const,
  metadata: (gId?: string) => ['channels', gId, 'metadata'] as const,
  members: (gId?: string, channelId?: string, roles?: string, searchText?: string) =>
    ['channels', gId, 'members', channelId, roles, searchText] as const,
  channelSuggestions: (gId?: string, channelId?: string, params?: unknown) =>
    ['channels', gId, 'channel-suggestions', channelId, params] as const,
  detail: (gId?: string, channelId?: string) => ['channels', gId, 'detail', channelId] as const,
  stats: (gId?: string, channelId?: string, locationId?: string) =>
    ['channels', gId, 'stats', channelId, locationId] as const,
} as const
